import React from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import location_icon from "svg/location.svg";
import "./style.scss";

const GooglePlaces = ({
  fieldClasses,
  label,
  id,
  isRequired,
  onChange,
  value,
  onSelect,
  placeholder,
  debounce,
  onBlur,
  errorMsg,
}) => {
  const searchOptions = {
    componentRestrictions: { country: "us" },
  };
  return (
    <PlacesAutocomplete
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      debounce={debounce}
      searchOptions={searchOptions}
    >
      {({ getInputProps, getSuggestionItemProps, suggestions, loading }) => (
        <div className={"autocomplete-root form-group custom-input position-relative"}>
          {label && (
            <label htmlFor={id} className="label_class">
              {label}
              {isRequired && <span className="required">*</span>}
            </label>
          )}
          <input
            {...getInputProps()}
            className={fieldClasses + (errorMsg && errorMsg !== "" ? " error-field" : "")}
            id={id}
            placeholder={placeholder}
          />
          <div
            className={`autocomplete-dropdown-container position-absolute ${suggestions.length ? "d-block" : "d-none"}`}
          >
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion, index) => (
              <div {...getSuggestionItemProps(suggestion)} className={"suggestion-item"} key={index}>
                <div className="d-flex">
                  <img src={location_icon} alt="..." className="margin-2" />
                  <span>{suggestion.description}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default GooglePlaces;
